module.exports = __webpack_public_path__ + "img/icon_shibiezimu.06d7f1c7.svg";